module.exports = __webpack_public_path__ + "static/img/reimaging-onboarding-data05.c6792af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/details-page/reimaging-onboarding-data05.png
// module id = 4efR
// module chunks = 1